import { Injectable, signal } from '@angular/core';

export type AppConfirmTone = 'danger' | 'neutral' | 'warning';

export interface AppConfirmOptions {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: AppConfirmTone;
}

export interface AppConfirmRequest {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  tone: AppConfirmTone;
  resolve: (confirmed: boolean) => void;
}

@Injectable({ providedIn: 'root' })
export class AppConfirmService {
  private readonly activeRequest = signal<AppConfirmRequest | null>(null);
  readonly request = this.activeRequest.asReadonly();

  confirm(options: AppConfirmOptions): Promise<boolean> {
    const currentRequest = this.activeRequest();
    if (currentRequest) {
      currentRequest.resolve(false);
    }

    return new Promise<boolean>((resolve) => {
      this.activeRequest.set({
        title: options.title ?? 'Confirm action',
        message: options.message,
        confirmLabel: options.confirmLabel ?? 'Confirm',
        cancelLabel: options.cancelLabel ?? 'Cancel',
        tone: options.tone ?? 'neutral',
        resolve
      });
    });
  }

  accept(): void {
    this.close(true);
  }

  cancel(): void {
    this.close(false);
  }

  private close(confirmed: boolean): void {
    const currentRequest = this.activeRequest();
    if (!currentRequest) {
      return;
    }

    this.activeRequest.set(null);
    currentRequest.resolve(confirmed);
  }
}
